import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Properties API
export const propertiesApi = {
  list: (params) => axios.get(`${API}/properties`, { params }),
  get: (id) => axios.get(`${API}/properties/${id}`),
  create: (data) => axios.post(`${API}/properties`, data),
  update: (id, data) => axios.put(`${API}/properties/${id}`, data),
  delete: (id) => axios.delete(`${API}/properties/${id}`),
  myProperties: () => axios.get(`${API}/my-properties`),
};

// Favorites API
export const favoritesApi = {
  list: () => axios.get(`${API}/favorites`),
  listIds: () => axios.get(`${API}/favorites/ids`),
  add: (propertyId) => axios.post(`${API}/favorites/${propertyId}`),
  remove: (propertyId) => axios.delete(`${API}/favorites/${propertyId}`),
};

// Cities API (5 main cities with detailed data for blog/news)
export const citiesApi = {
  list: () => axios.get(`${API}/cities`),
  get: (name) => axios.get(`${API}/cities/${name}`),
};

// Wilayas API (all 48 wilayas for property listings)
export const wilayasApi = {
  list: () => axios.get(`${API}/wilayas`),
};

// Articles API
export const articlesApi = {
  list: (params) => axios.get(`${API}/articles`, { params }),
  get: (slug) => axios.get(`${API}/articles/${slug}`),
};

// Contact requests API
export const contactRequestsApi = {
  list: () => axios.get(`${API}/contact-requests`),
  create: (data) => axios.post(`${API}/contact-requests`, data),
};

// Notifications API
export const notificationsApi = {
  list: () => axios.get(`${API}/notifications`),
  unreadCount: () => axios.get(`${API}/notifications/unread-count`),
  markRead: (id) => axios.put(`${API}/notifications/${id}/read`),
  markAllRead: () => axios.put(`${API}/notifications/read-all`),
};

// Agencies API
export const agenciesApi = {
  list: (params) => axios.get(`${API}/agencies`, { params }),
  get: (id) => axios.get(`${API}/agencies/${id}`),
  getProperties: (id, params) => axios.get(`${API}/agencies/${id}/properties`, { params }),
  getMyProfile: () => axios.get(`${API}/agencies/profile`),
  updateProfile: (data) => axios.post(`${API}/agencies/profile`, data),
};

// Stats API
export const statsApi = {
  get: () => axios.get(`${API}/stats`),
};

// Price Map API
export const priceMapApi = {
  get: () => axios.get(`${API}/price-map`),
};

// Seed API
export const seedApi = {
  seed: () => axios.post(`${API}/seed`),
};

// Format price helper
export const formatPrice = (price, isMonthly = false) => {
  if (!price) return 'N/A';
  const formatted = new Intl.NumberFormat('fr-DZ').format(price);
  return isMonthly ? `${formatted} DA/mois` : `${formatted} DA`;
};

// Format surface helper
export const formatSurface = (surface) => {
  return surface ? `${surface} m²` : 'N/A';
};

// Property type labels
export const propertyTypes = {
  fr: {
    appartement: 'Appartement',
    maison: 'Maison',
    villa: 'Villa',
    terrain: 'Terrain',
    commercial: 'Local commercial',
    bureau: 'Bureau',
  },
  ar: {
    appartement: 'شقة',
    maison: 'منزل',
    villa: 'فيلا',
    terrain: 'أرض',
    commercial: 'محل تجاري',
    bureau: 'مكتب',
  }
};

// Transaction type labels
export const transactionTypes = {
  fr: {
    vente: 'Vente',
    location: 'Location',
  },
  ar: {
    vente: 'بيع',
    location: 'إيجار',
  }
};
